import {
  Box,
  Input,
  Image
} from '@chakra-ui/react'
import { ACCEPTED_IMG_LIST } from 'utils/constants'
import { AddImageIcon } from 'assets/icons'
import { ImagesPng } from 'assets/images'
import { COLORS } from 'utils/styles'

export const ProfileAvatar = ({ inputFileRef, handleUploadFile, profilePicture }) => {
  const UploadClick = (event) => inputFileRef.current.click()
  /* eslint-disable jsx-a11y/label-has-associated-control */
  return (
    <>
      <Box
        position="relative"
        top="-10px"
      >
        <Box position="absolute" top="6" right="-8px">
          <label
            style={{ cursor: 'pointer' }}
            name="add-profile-img"
            htmlFor="userImg"
          >
            <AddImageIcon />
          </label>
        </Box>

        <Image
          boxSize="65px"
          objectFit="cover"
          src={profilePicture?.imagePath || ImagesPng?.DefaultImage}
          alt="User Image"
          borderRadius="full"
          border={`1.5px solid ${COLORS.gray_op8}`}
          onClick={UploadClick}
        />

      </Box>
      <Input
        display="none"
        ref={inputFileRef}
        id="userImg"
        type="file"
        onChange={handleUploadFile}
        accept={ACCEPTED_IMG_LIST}
      />
    </>
  )
}
